export default "__VITE_PUBLIC_ASSET__94ec9b3d__"